import { stripLabelQuotes } from '@/components/quick-study-results/quickStudyPure'

/** Cap for a short option label. Long enough for a real concept name, short enough that a
 *  standfirst sentence or a cite chip never turns into a paragraph. */
export const SHORT_OPTION_LABEL_MAX = 60

/**
 * D3-style short label: the text before the first separator, trimmed and capped.
 * Survey-authored option labels routinely glue a name to its description
 * ("Trust, Amplified: A guide to using AI responsibly ...", "AI Advantage - A practical
 * guide ..."), and quoting the FULL text turns a band standfirst or a cite chip into a
 * concept dump (Step 5b visual QA findings 3 and 5). Separators recognised: a spaced
 * hyphen/en dash/em dash (" - ", " – ", " — ") and a colon followed by a space (": ").
 *
 * Mirrors the split rule `finding_exhibit_specs.py::_short_option_label` uses for chart
 * categories, kept in TypeScript on purpose — never import python or chart code here.
 * Shared by `resolveMagazineBandSource` (standfirst) and `enrichStudyDocQuote` (cite chip)
 * so both surfaces name a concept the same way.
 */
export function shortOptionLabel(label: string, maxLength = SHORT_OPTION_LABEL_MAX): string {
  const cleaned = stripLabelQuotes(label).trim()
  const separator = cleaned.match(/\s[-–—]\s|:\s/)
  const base =
    separator && typeof separator.index === 'number' && separator.index > 0
      ? cleaned.slice(0, separator.index).trim()
      : cleaned
  if (base.length <= maxLength) {
    return base
  }
  return base.slice(0, maxLength).trim()
}
